<template>
  <div id="app">
    <yp-navbar ref="navbar"></yp-navbar>
    <div id="dowebok">
      <div class="section">
        <div class="swiper">
          <div class="yp-slide-img" @click="fullpageDown()">
            <img src="/static/img/mouse.png" alt="" class="yp-slide-img1" />
            <img src="/static/img/slide.png" alt="" />
          </div>
          <swiper v-if="nowSizeChange()" class="firstSwiper" :options="firstSwiperOptions">
            <swiper-slide v-for="(item, index) in largeImgList" :key="index">
              <img :src="item.img" alt="" />
              <div class="yp-inner" v-if="item.displayorder === 1">
                <div class="yp-inner-title">我们为您提供零售信息化解决方案</div>
                <div class="yp-inner-box">
                  <div class="yp-inner-one"></div>
                  <div class="yp-inner-text">
                    WE OFFER YOU <br />
                    RETAIL INFORMATIZATION SOLUTIONS.
                  </div>
                </div>
                <div class="yp-moreBox">
                  <div class="yp-more">
                    <div class="yp-more-text">了解更多</div>
                  </div>
                  <div class="yp-more1">
                    <div class="yp-more-text">了解更多</div>
                  </div>
                </div>
              </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
          <swiper v-else class="firstSwiper" :options="firstSwiperOptions">
            <swiper-slide v-for="(item, index) in smallImgList" :key="index">
              <img :src="item.img" alt="" />
              <div class="yp-inner" v-if="item.displayorder === 1">
                <div class="yp-inner-title">我们为您提供<br />零售信息化解决方案</div>
                <div class="yp-inner-box">
                  <div class="yp-inner-one"></div>
                  <div class="yp-inner-text">
                    WE OFFER YOU <br />
                    RETAIL INFORMATIZATION SOLUTIONS.
                  </div>
                </div>
                <div class="yp-moreBox">
                  <div class="yp-more">
                    <div class="yp-more-text">了解更多</div>
                  </div>
                  <div class="yp-more1">
                    <div class="yp-more-text">了解更多</div>
                  </div>
                </div>
              </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </div>
      <div class="section">
        <div class="gotoInfo">
          <!-- yc -->
          <div class="gotoInfo-item">
            <div class="gotoInfo-item-one" id="content-box-info">
              <div v-for="(item, index) in gotoInfoList" :key="index" :class="'gotoInfo-item-company ' + item.color">
                <div><img :src="item.img" /></div>
                <div class="gotoInfo-item-info">
                  {{ item.companyTitle }}
                </div>
                <div v-if="nowSizeChange()" class="gotoInfo-item-info-min">
                  {{ item.title }}
                </div>
              </div>
            </div>
            <div class="gotoInfo-item-three">
              <!-- 介绍部分 -->
              <div class="gotoInfo-three-title">ABOUT YUEPENG</div>
              <div class="gotoInfo-three-two">走进悦朋</div>
              <div class="line-class"></div>
              <div class="line-content" id="lineContent">
                山东悦朋智能科技有限公司，是深圳优讯龙腾科技有限公司旗下的全资子公司，位于山东省威海市；公司专注于利用大数据、云计算、物联网、人工智能等新兴技术，为传统行业数字化、智慧化提供一体化
                设计、建设、运营服务，推动产业转型升级，提供从顶层设计、咨询规划、平台建设、产品集成到数据运营和生态发展的端到端“一揽子”解决方案和服务。
              </div>
              <!-- 内容展示 -->
              <div class="content-box-content">
                <div class="content-box" id="boxImgImg">
                  <div class="content-box-item">
                    <div class="context_box-img">
                      <div>
                        <img src="static/img/tv.png" alt="" />
                      </div>
                      <div>历史悠久</div>
                    </div>
                  </div>
                  <div class="content-box-item">
                    <div class="context_box-img">
                      <div>
                        <img src="static/img/meeting.png" alt="" class="img-responsive center-block" />
                      </div>
                      <div>实力卓越</div>
                    </div>
                  </div>
                  <div class="content-box-item">
                    <div class="context_box-img">
                      <div>
                        <img src="static/img/to-do.png" alt="" />
                      </div>
                      <div>专注专业</div>
                    </div>
                  </div>
                  <div class="content-box-item">
                    <div class="context_box-img">
                      <div>
                        <img src="static/img/handover.png" alt="" />
                      </div>
                      <div>客户云集</div>
                    </div>
                  </div>
                  <div class="content-box-item">
                    <div class="context_box-img">
                      <div>
                        <img src="static/img/apply.png" alt="" />
                      </div>
                      <div>精英团队</div>
                    </div>
                  </div>
                  <div class="content-box-item">
                    <div class="context_box-img">
                      <div>
                        <img src="static/img/tv.png" alt="" />
                      </div>
                      <div>贴心服务</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section section3">
        <div class="product-center">
          <div class="product-text">PRODUCT CENTER</div>
          <div class="product-title">产品中心</div>
          <div class="product-line-box">
            <div class="product-line"></div>
          </div>
        </div>

        <div class="product-swiper">
          <swiper v-if="nowSizeChange()" :options="productSwiperOptions">
            <swiper-slide v-for="(item, index) in productList" :key="index">
              <!-- <img :src="item.img" alt="" /> -->
              <div :class="'swiper-bac-img'" v-lazy:background-image="item.background">
                <div class="swiper-box-model">
                  <div class="swiper-bac-box">
                    <div class="swiper-bac-box-title">{{ item.title }}</div>
                    <div class="swiper-bac-content-text">
                      {{ item.content }}
                    </div>
                  </div>
                </div>
              </div>
            </swiper-slide>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
          <swiper v-else :options="productSwiperOptionsmin" class="slide-center-box">
            <swiper-slide v-for="(item, index) in productList" :key="index">
              <!-- <img :src="item.img" alt="" /> -->
              <div :class="'swiper-bac-img'" v-lazy:background-image="item.background">
                <div class="swiper-box-model">
                  <div class="swiper-bac-box">
                    <div>{{ item.title }}</div>
                    <div class="swiper-bac-content-text">
                      {{ item.content }}
                    </div>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
      <div class="section section4">
        <div class="information-center">
          <div class="information-text">CASE PRESENTATION</div>
          <div class="information-title">案例展示</div>
          <div class="information-line-box">
            <div class="information-line"></div>
          </div>
          <!-- 图片展示部分 -->
          <div class="information-carousel-img" id="informationCarouselImg">
            <!-- <div class="wrapper"> -->
            <swiper v-if="nowSizeChange()" ref="mySwiper" :options="swiperOptions">
              <swiper-slide v-for="(item, index) in swiperList" :key="index" :class="index % 2 == 0 ? 'opactity7' : 'opactity6'">
                <div class="" @mouseenter="imgmouseen(...arguments, item)">
                  <img :src="item.img" alt="" />
                </div>
              </swiper-slide>
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
            <swiper v-else ref="mySwiper" :options="swiperOptionsmin">
              <swiper-slide v-for="(item, index) in swiperList" :key="index" class="opactity7">
                <img v-lazy="item.img" alt="" />
                <div class="img-box-title" slot>{{ item.title }}</div>
              </swiper-slide>
              <div class="swiper-pagination pagemin-class-style" slot="pagination"></div>
            </swiper>
            <!-- </div> -->
            <!-- 展示块的位置 -->
            <div class="informaition-img">
              <!-- 展示块的内容 -->
            </div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="newscenter-center">
          <div class="newscenter-text">NEWS CENTER</div>
          <div class="newscenter-title">新闻中心</div>
          <div class="newscenter-line-box">
            <div class="newscenter-line" style="background: #1a2a7d"></div>
          </div>
          <div class="newscenter">
            <div class="yc-class-row">
              <div class="yp-box">
                <div class="yp-box-title">行业资讯</div>
                <div class="yp-box-titleEn">INDUSTRY INFORMATION</div>
                <img class="yp-box-next" src="/static/img/arrow.png" alt="" @click="handleClickIndustryList()" />
                <div class="yp-box-line"></div>
                <div class="yp-box-main" @click="handleClickIndustry(industryNewsListSplice)">
                  <img :src="this.industryNewsListSplice.mainpicture" alt="" class="yp-box-main-left" />
                  <div class="yp-box-main-right">
                    <div class="yp-box-main-haed">{{ formatYear(this.industryNewsListSplice.createtime) }}</div>
                    <div v-if="nowSizeChange()" class="yp-box-main-date">{{ formatMonthDay(this.industryNewsListSplice.createtime) }}</div>
                    <div v-else class="yp-box-main-date">{{ formatDate(this.industryNewsListSplice.createtime) }}</div>
                    <div class="yp-box-line"></div>
                    <div class="yp-box-main-title">{{ this.industryNewsListSplice.title }}</div>
                    <div class="yp-box-main-text">{{ this.industryNewsListSplice.digest }}</div>
                  </div>
                </div>
                <div class="yp-box-line yp-box-line-none"></div>
                <div class="yp-box-footer">
                  <div class="yp-box-footer-div" v-for="(item, index) in industryNewsList" :key="index" @click="handleClickIndustry(item)">
                    <span>{{ item.title }}</span
                    ><span>{{ formatMonthDayList(item.createtime) }}</span>
                  </div>
                </div>
              </div>
              <div class="yp-box">
                <div class="yp-box-title">公司动态</div>
                <div class="yp-box-titleEn">COMPANY DYNAMICS</div>
                <img class="yp-box-next" src="/static/img/arrow.png" alt="" @click="handleClickCompanyList()" />
                <div class="yp-box-line"></div>
                <div class="yp-box-main" @click="handleClickCompany(companyNewsListSplice)">
                  <img :src="this.companyNewsListSplice.mainpicture" alt="" class="yp-box-main-left" />
                  <div class="yp-box-main-right">
                    <div class="yp-box-main-haed">{{ formatYear(this.companyNewsListSplice.createtime) }}</div>
                    <div v-if="nowSizeChange()" class="yp-box-main-date">{{ formatMonthDay(this.companyNewsListSplice.createtime) }}</div>
                    <div v-else class="yp-box-main-date">{{ formatDate(this.industryNewsListSplice.createtime) }}</div>
                    <div class="yp-box-line"></div>
                    <div class="yp-box-main-title">{{ this.companyNewsListSplice.title }}</div>
                    <div class="yp-box-main-text">{{ this.companyNewsListSplice.digest }}</div>
                  </div>
                </div>
                <div class="yp-box-line yp-box-line-none"></div>
                <div class="yp-box-footer">
                  <div class="yp-box-footer-div" v-for="(item, index) in companyNewsList" :key="index" @click="handleClickCompany(item)">
                    <span>{{ item.title }}</span
                    ><span>{{ formatMonthDayList(item.createtime) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <yp-footer></yp-footer>
      </div>
    </div>
  </div>
</template>

<script>
import YpNavbar from '@/components/navbar.vue'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import '../index/index.scss'
import 'swiper/swiper.min.css'
// import CasePresentation from './components/case-presentation.vue'
import YpFooter from '@/components/footer.vue'
import config from '/config.js'

export default {
  components: {
    YpNavbar,
    YpFooter,
    Swiper,
    SwiperSlide,
    // CasePresentation
  },
  created() {
    Media($(window).width())

    $(function () {
      $('#dowebok').fullpage({
        menu: '#menu',
        // autoScrolling: false,
        onLeave: function (index, nextIndex) {
          // nextIndex 进入下一个页面的索引值
          if (nextIndex.index === 0) {
            $('.navbar').removeClass('no-transparent-navbar')
            // $('.dropdown-menu').css('background', 'rgba(0, 0, 0, 0)')
            // $('.dropdown-toggle').css('background', 'rgba(0, 0, 0, 0)')
          } else {
            $('.navbar').addClass('no-transparent-navbar')
            // $('.dropdown-menu').css('background', '#333')
            // $('.dropdown-toggle').css('background', '#333')
          }
        },
      })
    })
    function Media(width) {
      if (width > 750) {
        refreshRem(1920)
      } else {
        refreshRem(750)
      }
    }
    // 根据设计图尺寸计算rem
    function refreshRem(designSize) {
      let html = document.documentElement
      let wW = html.clientWidth // 窗口宽度
      let rem = (wW * 100) / designSize
      document.documentElement.style.fontSize = rem + 'px'
    }
    // alert(document.documentElement.clientWidth)
    // alert(document.documentElement.clientHeight)
  },
  mounted() {
    // $('.dropdown-menu').css('background', 'rgba(0, 0, 0, 0)')
    // $('.dropdown-toggle').css('background', 'rgba(0, 0, 0, 0)')
  },
  data() {
    return {
      pageIndex: 1,
      pageSize: 5,
      industryNewsList: [], // 行业资讯
      industryNewsListSplice: {}, // 首个行业资讯
      companyNewsList: [], // 公司动态
      companyNewsListSplice: {}, // 首个公司动态
      largeImgList: [
        {
          img: './static/img/banner1.jpeg',
          title: '行业资讯',
          displayorder: 1
        },
         {
          img: './static/img/banner2.jpeg',
          title: '行业资讯'
        }
      ], // 大图片集合
      smallImgList: [], // 小图片集合
      swiperListTopDate: {
        loop: false,
        speed: 2000,
        // 显示分页
        pagination: {
          el: '.swiper-pagination',
          clickable: true, //允许分页点击跳转
        },
        // 设置点击箭头
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      swiperOptions: {
        slidesPerView: 5,
        grid: {
          fill: 'row',
          rows: 2,
        },
        loop: false,
        speed: 2000,
        // 显示分页
        // 设置点击箭头
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      swiperOptionsmin: {
        slidesPerView: 2,
        grid: {
          fill: 'row',
          rows: 3,
        },
        spaceBetween: 20,
        loop: false,
        speed: 1000,
        // 显示分页
        pagination: {
          el: '.swiper-pagination',
          clickable: true, //允许分页点击跳转
        },
        // 设置点击箭头
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      firstSwiperOptions: {
        slidesPerView: 1,
        initialSlide: 1,
        loop: true,
        autoplay: {
          delay: 3000,
        },
        pagination: {
          el: '.swiper-pagination',
        },
      },
      productSwiperOptions: {
        // loop: true,
        slidesPerView: 4,
        spaceBetween: 0,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      productSwiperOptionsmin: {
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 10,
        speed: 1000,
        loop: true,
      },
      gotoInfoList: [
        {
          img: './static/img/setting.png',
          companyTitle: '深圳市优讯智能卡有限公司',
          title: '智能卡、RFID电子标签',
          color: 'a2A7D',
        },
        {
          img: './static/img/dropsofwater.png',
          companyTitle: '济南友宾供应链管理有限公司',
          title: '供应链运营服务',
          color: 'C2B28',
        },
        {
          img: './static/img/fire.png',
          companyTitle: '简单零售科技(深圳)有限公司',
          title: '银行金融IT服务',
          color: 'E94824',
        },
        {
          img: './static/img/lightning.png',
          companyTitle: '深圳市优讯信息技术有限公司',
          title: '银行金融IT服务',
          color: 'F18B2D',
        },
      ],
      swiperList: [
        {
          img: '/static/images/jjy.png',
          title: '家家悦',
        },
        {
          img: '/static/images/wb.png',
          title: '潍百集团',
        },
        {
          img: '/static/images/szd.png',
          title: '商之都',
        },
        {
          img: '/static/images/hxgw.png',
          title: '华信购物广场',
        },
        {
          img: '/static/images/bd.png',
          title: '百大集团',
        },
        {
          img: '/static/images/zyh.png',
          title: '卓悦汇',
        },
        {
          img: '/static/images/yfc.png',
          title: '壹方城',
        },
        {
          img: '/static/images/mh.png',
          title: '明湖商场',
        },
        {
          img: '/static/images/glc.png',
          title: '港隆城',
        },
        {
          img: '/static/images/jz.png',
          title: '嘉州廣場',
        },
        {
          img: '/static/images/hxgc.png',
          title: '和信广场',
        },
        {
          img: '/static/images/fdl.png',
          title: '福到来',
        },
        {
          img: '/static/images/rb.png',
          title: 'RB日百',
        },
        {
          img: '/static/images/jgh.png',
          title: '金光崋廣場',
        },
        {
          img: '/static/images/lj.png',
          title: '荔晶购物中心',
        },
        {
          img: '/static/images/sp.png',
          title: '升平百货',
        },
        {
          img: '/static/images/hb.png',
          title: '华百广场',
        },
        {
          img: '/static/images/xjc.png',
          title: '熙璟诚',
        },
        {
          img: '/static/images/rj.png',
          title: '荣基国际广场',
        },
        {
          img: '/static/images/yzj.png',
          title: '宜之佳',
        },
      ],
      // swiperList: [
      //   {
      //     img: './static/img/weihaikowloon.png',
      //     title: '威海九龙城',
      //   },
      //   {
      //     img: './static/img/mahjonglayout.png',
      //     title: '壹方城项目',
      //   },
      //   {
      //     img: './static/img/humenInternational.png',
      //     title: '虎门国际购物中心',
      //   },
      //   {
      //     img: './static/img/figurein.png',
      //     title: '花样年',
      //   },
      //   {
      //     img: './static/img/jinGuanghua.png',
      //     title: '深圳金光华',
      //   },
      //   {
      //     img: './static/img/weihaikowloon.png',
      //     title: '威海九龙城',
      //   },
      //   {
      //     img: './static/img/figurein.png',
      //     title: '花样年',
      //   },
      //   {
      //     img: './static/img/humenInternational.png',
      //     title: '虎门国际购物中心',
      //   },
      //   {
      //     img: './static/img/figurein.png',
      //     title: '花样年',
      //   },
      //   {
      //     img: './static/img/weihaikowloon.png',
      //     title: '威海九龙城',
      //   },
      //   // {
      //   //   img: './static/img/jinGuanghua.png',
      //   //   title: '深圳金光华',
      //   // },
      // ],

      productList: [
        {
          img: '/static/img/Project.png',
          background: './static/img/Project.png',
          title: '工程项目',
          content: '每一种色彩的运用， 在品牌传达中起到关键性的作用。比如相对暖色调的颜色 红色 橙色 黄色。',
        },
        {
          img: '/static/img/invoiceManagement.png',
          background: './static/img/invoiceManagement.png',
          title: 'COM',
          content: '通过客户标签、建模、画像、自动化营销、人工营销等一系列手段配合，帮助企业更加精准的认识、识别客户，完成营销策略。',
        },
        {
          img: '/static/img/departmentStoreone.png',
          background: './static/img/departmentStoreone.png',
          title: 'O2O',
          content: '客流提升，提高增长力，降低成本，顾客离店关联',
        },
        {
          img: '/static/img/连锁超市管理系统.png',
          background: './static/img/连锁超市管理系统.png',
          title: '连锁超市管理系统',
          content: '各种类型的连锁超市企业的综合管理系统，涵盖进销调存、财务结算等各种模块。',
        },
        {
          img: '/static/img/供应商网上平台.png',
          background: './static/img/供应商网上平台.png',
          title: '供应商网上平台',
          content: '针对连锁超市企业的供应商网上管理，涵盖对账、下订单、查库存等各种模块。',
        },
        {
          img: '/static/img/departmentStoreone.png',
          background: './static/img/departmentStoreone.png',
          title: '百货管理系统',
          content: '传统百货企业的综合管理系统，涵盖以合同为中心的百货管理模块。',
        },
        {
          img: '/static/img/购物中心综合管理系统.png',
          background: './static/img/购物中心综合管理系统.png',
          title: '购物中心综合管理系统',
          content: '以商业地产为核心的购物中心模式的综合管理系统，涵盖招商、运营、租赁、物业、财务、数据接口等各种模块.',
        },
        {
          img: '/static/img/专营专卖.png',
          background: './static/img/专营专卖.png',
          title: '专营专卖',
          content: '根据不同业态（如服装连锁、家电连锁、数码产品连锁）而开发的特定行业的信息管理系统，符合企业所在行业的不同特性。',
        },
        {
          img: '/static/img/RF运营管理系统.png',
          background: './static/img/RF运营管理系统.png',
          title: 'RF营运管理系统',
          content: '涵盖以RF枪为载体的收货、盘点等各种模块，支持联网、脱机模式。。',
        },
        {
          img: '/static/img/财务接口平台.png',
          background: './static/img/财务接口平台.png',
          title: '财务接口平台',
          content: '可以对零售企业的各种软件（如ERP、停车场、物业等）进行财务对接，自动生成符合零售企业要求的各种凭证。',
        },
      ],
    }
  },
  beforeMount() {
    if (!window.__INITIAL_STATE__) {
      this.loadData()
    }
  },
  methods: {
    fullpageDown() {
      $.fn.fullpage.moveSectionDown()
    },
    formatDate(time) {
      if (time !== undefined) {
        var list = time.split(' ')
        var list1 = list[0].split('-')
        var year = list1[0]
        var month = list1[1]
        var day = list1[2]
        return year + '年' + month + '月' + day + '日'
      }
    },
    formatYear(time) {
      if (time !== undefined) {
        var list = time.split(' ')
        var list1 = list[0].split('-')
        var year = list1[0]
        return year
      }
    },
    formatMonthDay(time) {
      if (time !== undefined) {
        var list = time.split(' ')
        var list1 = list[0].split('-')
        var month = list1[1]
        var day = list1[2]
        return month + '月' + day + '日'
      }
    },
    formatMonthDayList(time) {
      if (time !== undefined) {
        var list = time.split(' ')
        var list1 = list[0].split('-')
        var month = list1[1]
        var day = list1[2]
        return month + '-' + day
      }
    },
    loadData() {
      // this.handleLoadData({
      //   name: '',
      //   bannertypecode: '01', //01默认首页
      //   pageIndex: 1,
      //   pageSize: 999,
      //   status: true, //是否有效
      //   islarge: '', //是否大图
      // })
      this.handleLoadIndustryNewsListData({
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        title: '',
        status: true,
        newstypecode: '01',
      })
      this.handleLoadCompanyNewsListListData({
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        title: '',
        status: true,
        newstypecode: '02',
      })
    },
    handleLoadData(query) {
      // 调用接口
      $.ajax({
        url: `${config.apiBaseUrl}/api/v1.0/banner/getBannerList`,
        data: query,
        success: (res) => {
          const data = res.data
          data.data.forEach((item) => {
            if (item.islarge) {
              let obj = {}
              obj.img = item.url
              obj.displayorder = item.displayorder
              this.largeImgList.push(obj)
            } else {
              let obj = {}
              obj.img = item.url
              obj.displayorder = item.displayorder
              this.smallImgList.push(obj)
            }
          })
        },
      })
    },
    handleLoadIndustryNewsListData(query) {
      // 调用接口
      $.ajax({
        url: `${config.apiBaseUrl}/api/v1.0/news/getNewsList`,
        data: query,
        success: (res) => {
          const data = res.data
          this.industryNewsList = data.data.splice(1)
          this.industryNewsListSplice = data.data[0]
        },
      })
    },
    handleLoadCompanyNewsListListData(query) {
      // 调用接口
      $.ajax({
        url: `${config.apiBaseUrl}/api/v1.0/news/getNewsList`,
        data: query,
        success: (res) => {
          const data = res.data
          this.total = data.total
          this.companyNewsList = data.data.splice(1)
          this.companyNewsListSplice = data.data[0]
        },
      })
    },
    handleClickIndustry(doc) {
      location.href = config.getDocUrl('industryNewsDetails', doc.id)
    },
    handleClickCompany(doc) {
      location.href = config.getDocUrl('companyNewsDetails', doc.id)
    },
    handleClickIndustryList() {
      location.href = config.getDocUrl('industryNews')
    },
    handleClickCompanyList() {
      location.href = config.getDocUrl('companyNews')
    },
    imgmouseen(e, item) {
      if ($('.information-carousel-img .informaition-img')[0].style.display === '') {
        var clickBox = e.target.getBoundingClientRect()
        // 判断当前点击的位置，如果超出屏幕则要改变移动位置的距离
        var number = document.documentElement.clientWidth
        var leftSlide = clickBox.x
        var topSlide = clickBox.y
        if (leftSlide >= number - 384) {
          leftSlide = leftSlide - 172
        }
        // 填充快的位置
        $('.information-carousel-img .informaition-img').css('left', leftSlide / 100 + 'rem')
        $('.information-carousel-img .informaition-img').css('top', (topSlide - 330) / 100 + 'rem')
        $('.information-carousel-img .informaition-img').css('display', 'block')
        // 展示块展示的内容
        var informaitionImgHtml = ''
        informaitionImgHtml = ` <div class="informaition-img-title">
               ${item.title}
             </div>
             <div class="informaition-img-img">
               <img src="${item.img}" alt="">
               <div class="scanle" id="cancleEvent" title="关闭当前">
                 <img src="./static/img/scanle.png" alt="">
               </div>
             </div>`
        $('.informaition-img').append(informaitionImgHtml)

        // $('.informaition-img .informaition-img-title').css('height', `${yucFunction.rateNumber(100)}px`)
        // $('.informaition-img .informaition-img-title').css('font-size', `${yucFunction.rateNumber(36)}px`)
        // 注册点击事件(关闭展示块位置)
        $('.informaition-img #cancleEvent').click(() => {
          $('.information-carousel-img .informaition-img').css('display', '')
          $('.information-carousel-img .informaition-img').empty()
        })
        $('.informaition-img .informaition-img-img').on('mouseout', function () {
          $('#informationCarouselImg .informaition-img').css('display', '')
          $('.information-carousel-img .informaition-img').empty()
        })
      }
    },
    nowSizeChange() {
      if (document.documentElement.clientWidth < 751) {
        // 是移动端，不显示内容
        return false
      } else {
        return true
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.slide-center-box .swiper-slide {
  transform: scale(0.8) !important;
}
.swiper-slide-active,
.swiper-slide-duplicate-active {
  transform: scale(1) !important;
}
.swiper-bac-box-title {
  font-size: 0.22rem;
}
</style>
